module.exports = __webpack_public_path__ + "static/fitness-31e8bf19eaadab2627b499b3851b32ed.png";